<template>
  <article :post="post" :author="author" :categories="categories">
    <div class="container p-4">
      <div class="post-main">
        <div class="post-title">
          <h1>{{ post._embedded['wp:term'][0][0].name }}</h1>
        </div>
        <div class="row p-0">
          <div class="col-md-12">
            <div class="post">
              <div class="post-header">
                <img v-if="post._embedded['wp:featuredmedia']"
              :src="post._embedded['wp:featuredmedia'][0].source_url" width="650" height="auto">
                <h6 v-html="post._embedded['wp:featuredmedia'][0].caption.rendered"></h6>
                <div class="post-info">
                  <h2 v-html="post.title.rendered"></h2>
                  <router-link v-if="post._embedded['wp:term'][0][0].name!=='Autores'" :to="{ name:'author', params: {authorId: author.id} }">
                    {{post._embedded.author[0].name}}
                  </router-link>
                  <p v-if="post.acf.afu_periodo_fecha">{{post.acf.afu_periodo_fecha}}</p>
                </div>
              </div>
              <div class="post-content" id="post-content" v-html="post.content.rendered">
              </div>
              <div class="tags-wrapper">
                <h6>Etiquetas</h6>
                <div class="tag" v-for="tag in tags" :key="tag.id">
                  <router-link :to="{name:'tag', params: {tagSlug: tag.slug}}">{{ tag.name }},</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
  import axios from "axios";

  export default {
    name: 'Post',
    data () {
      return {
        title: '',
        content: '',
        queryOptions: {
          _embed: true,
        },
        post: [],
        categories: [],
        author: [],
        tags: []
      }
    },
    created () {
      this.getPost(),
      this.getCategory()
    },
    methods: {
    getPost () {
      var path = this.$route.path
      axios.get('https://foto-urbana.credopop.com/wp-json/wp/v2/posts/?slug=' + path.replace(/^\/|\/$/g, ''), {params:this.queryOptions})
      .then(response => {
        this.post = response.data[0]

        if (this.post === undefined) {
          this.$router.push({name: 'NotFound'})
        }

        this.getAuthor()
        this.getTags()
        this.getCategory()

        document.title = this.post.title.rendered
      })
      .catch(e => {
        console.log(e)
      })
    },
    getCategory() {
      axios.get('https://foto-urbana.credopop.com/wp-json/wp/v2/categories/', {params:this.queryOptions})
      .then(response => {
        this.categories = response.data
      })
      .catch(e => {
        console.log(e)
      })
    },
    getAuthor () {
      axios.get('https://foto-urbana.credopop.com/wp-json/wp/v2/users/' + this.post.author, {params:this.queryOptions})
      .then(response => {
        this.author = response.data
      })
    },
    getTags () {
      axios.get('https://foto-urbana.credopop.com/wp-json/wp/v2/tags?include=' + this.post.tags, {params:this.queryOptions})
      .then(response => {
        this.tags = response.data
      })
    }
  }
}
</script>
<style scoped>
a,
a:link,
a:visited,
a:active {
  color: #000000;
  opacity: 1.0;
  text-decoration: none;
}
#post-content >>> a,
#post-content >>> a:hover,
#post-content >>> a:active,
#post-content >>> a:visited {
  opacity: 1.0;
  text-decoration: none;
  color: #000;
}
.post img {
  width: 66.6%;
}
.post-main {
  margin-top: 50px;
  font-family: 'Raleway', sans-serif;
}
.post-title h1 {
  font-family: 'Raleway', sans-serif;
  font-size: 24px;
  font-size: 400;
  text-transform: uppercase;
  letter-spacing: 2.4px;
}
.post-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.post-header h6 {
  align-self: flex-end;
  position: absolute;
  left: 0;
  bottom: -40px;
  font-weight: 600;
}
.post-header img {
  margin: 20px 0;
}
.post-content {
  margin-top: 50px;
}
.post-info {
  margin: 0 40px;
}
.post-info h2 {
  font-family: 'Raleway', sans-serif;
  font-size: 42px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #000000;
}
.post-info p {
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  font-weight: 700;
}
.post-content p {
  font-size: 16px;
}
#post-content >>> p,
#post-content >>> a,
#post-content >>> figure figcaption {
  word-break: break-word;
}
#post-content >>> img {
  width: 80%;
  height: auto;
  margin: 20px 0;
}
#post-content >>> .newspaper-x-tags {
  display: none;
}
.tags-wrapper {
  display: flex;
  justify-content: flex-start;
}
.tags-wrapper h6 {
  font-family: 'Raleway', sans-serif;
  font-size: 18px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #000000;
}

.tags-wrapper .tag {
  padding-left: 5px;
  font-weight: bold;
}

@media(max-width: 1255px) {
  .post-header {
    flex-direction: column;
    justify-content: flex-start;
  }
  .post-info {
    margin: 0;
  }
  .post img {
    width: 100%;
  }
  .post-info h2 {
    font-size: 18px;
  }
  #post-content >>> img,
  #post-content >>> figcaption {
    max-width: 320px;
  }
}
</style>
